import {
  CircularProgress,
  Divider,
  Paper,
  useMediaQuery,
} from "@material-ui/core";
import useStyles from "./styles";

type Props = {
  countObject?: any;
  isLoading?: any;
  activeTab?: any;
  setActiveTab?: any;
  isDefaultFilter?: boolean;
};

const AspImpCountSection = ({
  countObject,
  isLoading,
  activeTab = null,
  setActiveTab,
  isDefaultFilter,
}: Props) => {
  const matches = useMediaQuery("(min-width:820px)");
  const smallScreen = useMediaQuery("(min-width:450px)");
  const classes = useStyles(matches)();

  const handleTabClick = (index: any) => {
    setActiveTab(index);
  };

  const sections = [
    {
      title: "Total Stages",
      subTitle: "(approved)",
      count: countObject?.totalAspImp,
    },
    { title: "InWorkflow Stages", count: countObject?.inWorkflowAspImp },
    {
      title: "Current Year Stages(New)",
      subTitle: "(approved+inWorkflow)",
      count: countObject?.currentYearAspImp,
    },
  ];

  return (
    <>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <>
          {isDefaultFilter ? (
            <div className={classes.parentDiv}>
              {/* Total Stage tab 0,1 */}
              <div className={classes.papermaincontain}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <p className={classes.headingText}>Total Stages</p>
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "normal",
                      margin: "0",
                    }}
                  >
                    (approved)
                  </p>
                </div>
                <Paper elevation={0} className={classes.paper}>
                  <div
                    className={`${classes.papercontainers}`}
                    style={{
                      cursor: "default", // Remove pointer cursor
                      color: "inherit", // Neutral text color
                    }}
                  >
                    <span className={classes.headingnumber1}>
                      {countObject?.totalEntityWise}
                    </span>
                    <span className={classes.headingname}>{`My Dept`}</span>
                  </div>
                  <Divider
                    orientation="vertical"
                    flexItem
                    className={classes.divider}
                  />
                  <div className={`${classes.papercontainers}`}>
                    <span className={classes.headingnumber}>
                      {countObject?.totalLocationWise}
                    </span>
                    <span className={classes.headingname}>{`My Unit`}</span>
                  </div>
                </Paper>
              </div>

              {/* InWorkflow Stage tab 4,5 */}
              <div
                className={classes.papermaincontain}
                style={{ marginTop: "10px" }}
              >
                <p
                  className={classes.headingText}
                  style={{ marginBottom: "10px" }}
                >
                  InWorkflow Stages
                </p>
                <Paper elevation={0} className={classes.paper}>
                  <div className={`${classes.papercontainers}`}>
                    <span className={classes.headingnumber1}>
                      {countObject?.inWorkflowEntityWise}
                    </span>
                    <span className={classes.headingname}>{`My Dept`}</span>
                  </div>
                  <Divider
                    orientation="vertical"
                    flexItem
                    className={classes.divider}
                  />
                  <div className={`${classes.papercontainers}`}>
                    <span className={classes.headingnumber}>
                      {countObject?.inWorkflowLocationWise}
                    </span>
                    <span className={classes.headingname}>{`My Unit`}</span>
                  </div>
                </Paper>
              </div>

              {/* Current Year Stage tab 2, 3 */}
              <div
                className={classes.papermaincontain}
                style={{ marginTop: "5px" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <p className={classes.headingText}>Current Year Stages</p>
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "normal",
                      margin: "0",
                    }}
                  >
                    (approved + inWorkflow)
                  </p>
                </div>
                <Paper elevation={0} className={classes.paper}>
                  <div className={`${classes.papercontainers}`}>
                    <span className={classes.headingnumber1}>
                      {countObject?.currentYearEntityWise}
                    </span>
                    <span className={classes.headingname}>{`My Dept`}</span>
                  </div>
                  <Divider
                    orientation="vertical"
                    flexItem
                    className={classes.divider}
                  />
                  <div className={`${classes.papercontainers}`}>
                    <span className={classes.headingnumber}>
                      {countObject?.currentYearLocationWise}
                    </span>
                    <span className={classes.headingname}>{`My Unit`}</span>
                  </div>
                </Paper>
              </div>
            </div>
          ) : (
            <div className={classes.parentDiv}>
              {sections.map((section, index) => (
                <div
                  key={index}
                  className={classes.papermaincontain}
                  style={
                    section?.title === "InWorkflow Stages"
                      ? { marginTop: "8px" }
                      : { marginTop: "0px" }
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <p
                      className={classes.headingText}
                      style={
                        section?.title === "InWorkflow Stages"
                          ? { marginTop: "13px" }
                          : { marginTop: "0px" }
                      }
                    >
                      {section.title}
                    </p>
                    {section?.subTitle && (
                      <p
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          margin: "0",
                        }}
                      >
                        {section?.subTitle}
                      </p>
                    )}
                  </div>
                  <Paper
                    elevation={5}
                    className={classes.paper}
                    style={{ height: "80%" }}
                  >
                    <div
                      className={`${classes.papercontainers}`}
                      style={{
                        cursor: "default", // Remove pointer cursor
                        color: "inherit", // Neutral text color
                      }}
                    >
                      <p className={classes.headingnumber}>{section.count}</p>
                    </div>
                  </Paper>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default AspImpCountSection;
